<template>
  <div
    class="row"
    data-testid="member-bamboo-hr-details"
  >
    <div class="col-sm-6">
      <div class="d-flex justify-content-between align-items-center my-20">
        <h6
          class="m-0"
          data-testid="member-bamboo-hr-details-title"
        >
          BambooHR details
        </h6>
        <a
          v-if="bambooHrUrl"
          data-testid="member-bamboo-hr-details-link"
          :href="bambooHrUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="strong text-default-size no-wrap"
        >
          Open in BambooHR
        </a>
      </div>
      <div class="form-group">
        <label class="control-label">Reports to</label>
        <AppInput
          data-test-id="member-bamboo-hr-reports-to"
          :value="bambooHrReportsTo"
          readonly
          placeholder="No reports to"
        />
      </div>
      <div class="form-group">
        <label class="control-label">Department</label>
        <AppInput
          data-test-id="member-bamboo-hr-department"
          :value="bambooHrDepartment"
          readonly
          placeholder="No department"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AppInput from '~/components/AppInput.vue';

export default {
  name: 'MemberBambooHrDetails',
  components: { AppInput },
  props: {
    bambooHr: {
      type: Object,
      required: true,
    },
  },
  computed: {
    bambooHrDepartment() {
      return this.bambooHr.department || '';
    },
    bambooHrReportsTo() {
      return this.bambooHr.reports_to || '';
    },
    bambooHrUrl() {
      return this.bambooHr.url || '';
    },
  },
};
</script>
